import type { ComponentProps } from "react";
import { generatePath, useNavigate } from "react-router-dom";
import { t } from "ttag";

import { ROUTES } from "@/app/router";
import { REFILL_TYPE } from "@/shared/models";
import { FullscreenAlert } from "@/shared/ui";
import { INTAKE_FORM_ROUTE } from "../router";

export const JourneyRestricted = (
  props: ComponentProps<typeof FullscreenAlert.Root>,
) => {
  const navigate = useNavigate();

  const handleContinue = () => {
    navigate(
      generatePath(INTAKE_FORM_ROUTE.ASSESSMENT_FORM, {
        userPreference: REFILL_TYPE.SYNC,
        productId: null,
      }),
    );
  };

  return (
    <FullscreenAlert.Root {...props}>
      <FullscreenAlert.Content theme="dark">
        <FullscreenAlert.Header>
          <FullscreenAlert.Title>{t`Begin your journey`}</FullscreenAlert.Title>
          <FullscreenAlert.Description>
            {t`Unlock the door to your health journey with our platform. Schedule your inaugural video call with a medical professional, marking the beginning of your personalized treatment plan. Let's embark together on this path towards improved well-being and vitality.`}
          </FullscreenAlert.Description>
        </FullscreenAlert.Header>

        <FullscreenAlert.Footer>
          <FullscreenAlert.Cancel
            variant="tertiary-dark"
            onClick={() => navigate(ROUTES.BASE)}
          >
            {t`Back`}
          </FullscreenAlert.Cancel>

          <FullscreenAlert.Action
            variant="secondary-dark"
            onClick={handleContinue}
          >
            {t`Next`}
          </FullscreenAlert.Action>
        </FullscreenAlert.Footer>
      </FullscreenAlert.Content>
    </FullscreenAlert.Root>
  );
};
